import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import InputGroup from '../../../../components/cms/form/inputGroup';
import MlFields from '../../../../components/cms/form/mlFields';
import InputFile from '../../../../components/cms/form/inputFile';
import PreviewImage from '../../../../components/previewImage';

const twoCols = { xs: 12, md: 6 };
const labelCols = { xs: 12, md: 6, xl: 2 };

const TwoColumns = ({
  t,
  errors,
  formData,
  onChangeMl,
  imageSrc,
}) => (
    <Col>
        <Row>
            <Col>
                <MlFields
                    onChange={onChangeMl}
                    formData={formData}
                    fields={({onChange, formData}) => (
                        <div>
                            <Row>
                                <Col {...labelCols}>
                                    <InputGroup
                                        name="title"
                                        label={t('Label')}
                                        errors={errors}
                                        onChange={onChange}
                                        formData={formData}
                                        icon="fa fa-pencil-square-o"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col {...twoCols}>
                                    <InputGroup
                                        name="title1"
                                        label={t('Title')}
                                        errors={errors}
                                        onChange={onChange}
                                        formData={formData}
                                        icon="fa fa-pencil-square-o"
                                    />
                                    <InputGroup
                                        name="content1"
                                        label={t('Content')}
                                        type="editor"
                                        errors={errors}
                                        onChange={onChange}
                                        formData={formData}
                                    />
                                </Col>
                                <Col {...twoCols}>
                                    <InputFile id="image1" >
                                        <PreviewImage src={imageSrc} alt="img" height="120" />
                                    </InputFile>
                                </Col>
                                <Col {...twoCols}>
                                    <InputFile id="image2" >
                                        <PreviewImage src={imageSrc} alt="img" height="120" />
                                    </InputFile>
                                </Col>
                                <Col {...twoCols}>
                                    <InputGroup
                                        name="title2"
                                        label={t('Title')}
                                        errors={errors}
                                        onChange={onChange}
                                        formData={formData}
                                        icon="fa fa-pencil-square-o"
                                    />
                                    <InputGroup
                                        name="content2"
                                        label={t('Content')}
                                        type="editor"
                                        errors={errors}
                                        onChange={onChange}
                                        formData={formData}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                    />
            </Col>
        </Row>
    </Col>
);

TwoColumns.propTypes = {
};

export default TwoColumns;



// WEBPACK FOOTER //
// ./src/views/projects/project-section/components/TwoColumns.jsx